export default __webpack_public_path__ + "static/media/layer_add.1a016382.png";